module.exports = "pegasus/assets/blocks/capture-1-basic.png";